import { DEFAULT_TIMEZONE_IANA } from "constants/dateConstants";
import { applySnapshot, flow, types } from "mobx-state-tree";

import api from "services/api";

import {
  convertDateToTimezone,
  convertZonedDateToUTC,
  formatDateTimeToUTC,
} from "utils/date";

const PublishAllContentStore = types
  .model({
    scheduleDate: types.maybe(types.string),
    isLoading: types.optional(types.boolean, false),
  })
  .actions(self => ({
    fetchScheduleDate: flow(function*() {
      self.isLoading = true;

      try {
        const { scheduleDate } = yield api.get(`/content/schedule/publish`);

        const scheduleDateConverted = scheduleDate
          ? convertDateToTimezone(
              scheduleDate,
              DEFAULT_TIMEZONE_IANA,
            ).toString()
          : undefined;
        applySnapshot(self, { ...self, scheduleDate: scheduleDateConverted });
      } catch (error) {
        console.log("error :>> ", error);
        throw error;
      } finally {
        self.isLoading = false;
      }
    }),

    publishAllContent: flow(function*(scheduleDate?: Date) {
      self.isLoading = true;

      try {
        if (scheduleDate) {
          yield api.post(`/content/schedule/publish`, {
            scheduleDate: formatDateTimeToUTC(
              convertZonedDateToUTC(scheduleDate, DEFAULT_TIMEZONE_IANA),
            ),
          });
        } else {
          yield api.post(`/content/publish`, {});
        }
      } catch (error) {
        console.log("error :>> ", error);
        throw error;
      } finally {
        self.isLoading = false;
      }
    }),

    cancelPublishing: flow(function*() {
      self.isLoading = true;

      try {
        yield api.delete(`/content/schedule/publish`);
      } catch (error) {
        console.log("error :>> ", error);
        throw error;
      } finally {
        self.isLoading = false;
      }
    }),
  }));

export default PublishAllContentStore.create();
